module.exports = __webpack_public_path__ + "fonts/Lato-MediumItalic.aa1a7512.woff";